const notificationComponentLoaders = Object.freeze({
  'notifications.log-workspace': async () => {
    const module = await import('./notification-log-workspace-component.js');
    return module.NotificationLogWorkspaceComponent;
  },
});

export default notificationComponentLoaders;
